import React from "react";

const Section = ({ children, className, ...props }) => {
  return (
    <>
      <section className={`my-3 ${className}`} {...props}>
        {children}
      </section>
    </>
  );
};

export default Section;
